export default __webpack_public_path__ + "static/media/card3.ff273872.png";